export enum AppointmentType {
  Pending = 'pending',
  Confirmed = 'confirm',
  ToBeConfirmed = 'to_be_confirmed',
  Complete = 'complete',
  Cancel = 'cancel',
}
